import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FleetFuelIdlenessReport } from '../models/dtos/fleet-fuel-idleness-report';

@Injectable({
  providedIn: 'root'
})
export class FleetFuelIdlenessService {

  constructor(private http: HttpClient) { }

  getReport(windowDays: number): Observable<FleetFuelIdlenessReport> {
    const params = new HttpParams().set('windowDays', windowDays);
    return this.http
      .get(environment.apiHost + '/api-core/secure/boat/querys/fleet-fuel-idleness-report', { params })
      .pipe(map((response: any) => response));
  }
}
